"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "caravate": {
    "c4b21108": [{
      "hkey": "b1577da3",
      "slug": "caravate",
      "name": "Caravate",
      "primary": true,
      "skipSearch": false
    }],
    "cade": [{
      "hkey": "b1577da3",
      "slug": "caravate",
      "name": "Caravate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1fc9fcb9": [{
      "hkey": "b1577da3",
      "slug": "caravate",
      "name": "Caravate",
      "primary": true,
      "skipSearch": false
    }],
    "canton-d-oro": [{
      "hkey": "b1577da3",
      "slug": "caravate",
      "name": "Caravate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "814a0d45": [{
      "hkey": "b1577da3",
      "slug": "caravate",
      "name": "Caravate",
      "primary": true,
      "skipSearch": false
    }],
    "chiedo": [{
      "hkey": "b1577da3",
      "slug": "caravate",
      "name": "Caravate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8c93d79e": [{
      "hkey": "b1577da3",
      "slug": "caravate",
      "name": "Caravate",
      "primary": true,
      "skipSearch": false
    }],
    "fornace-farsani": [{
      "hkey": "b1577da3",
      "slug": "caravate",
      "name": "Caravate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c841c8c6": [{
      "hkey": "b1577da3",
      "slug": "caravate",
      "name": "Caravate",
      "primary": true,
      "skipSearch": false
    }],
    "fornazze": [{
      "hkey": "b1577da3",
      "slug": "caravate",
      "name": "Caravate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "58509f2f": [{
      "hkey": "b1577da3",
      "slug": "caravate",
      "name": "Caravate",
      "primary": true,
      "skipSearch": false
    }],
    "monte-san-giano": [{
      "hkey": "b1577da3",
      "slug": "caravate",
      "name": "Caravate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fca8ba98": [{
      "hkey": "b1577da3",
      "slug": "caravate",
      "name": "Caravate",
      "primary": true,
      "skipSearch": false
    }],
    "pozzei": [{
      "hkey": "b1577da3",
      "slug": "caravate",
      "name": "Caravate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "936474cd": [{
      "hkey": "b1577da3",
      "slug": "caravate",
      "name": "Caravate",
      "primary": true,
      "skipSearch": false
    }],
    "san-clemente": [{
      "hkey": "b1577da3",
      "slug": "caravate",
      "name": "Caravate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "51a11965": [{
      "hkey": "b1577da3",
      "slug": "caravate",
      "name": "Caravate",
      "primary": true,
      "skipSearch": false
    }],
    "santa-maria-del-sasso": [{
      "hkey": "b1577da3",
      "slug": "caravate",
      "name": "Caravate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c5a90fa4": [{
      "hkey": "b1577da3",
      "slug": "caravate",
      "name": "Caravate",
      "primary": true,
      "skipSearch": false
    }],
    "stallazzo": [{
      "hkey": "b1577da3",
      "slug": "caravate",
      "name": "Caravate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;